export default __webpack_public_path__ + "static/media/javascript.36bb4d11.png";